import React, { Component } from 'react';
import brandLogo from '../images/brand-logo-inverse-dark.png';
import { GENDER } from './OnboardingContainer.js';
import { Trans, translate } from 'react-i18next';
import { LANG } from '../App.js';
import Input from '../components/Input/index.jsx';

class Profile extends Component {
  handleBirthDate = (e) => {
    const birthDate = e.target.value.split('-');
    this.props.handleBirthDay({ target: { value: birthDate[2] } });
    this.props.handleBirthMonth({ target: { value: birthDate[1] } });
    this.props.handleBirthYear({ target: { value: birthDate[0] } });
  }

  render() {
    const { t } = this.props;
    const maxBirthYear = new Date();
    maxBirthYear.setFullYear(maxBirthYear.getFullYear() - 18);

    return (
      <div className="panel">
        <div className="panel-content">
          <div className="panel-heading-signup text-center">
            <img height="50px" alt="IOS OFFICES" src={brandLogo} />
          </div>
          <div className="panel-body-singup">
            <h4>{t('onboarding.profile.heading')}</h4>
            <form method="post" onSubmit={this.props.handleProfileSubmit}>
              <div className='row-auto'>
                <div className="form-group col-md-6">
                  <Input
                    className="form-control"
                    onChange={this.props.handleNameChange}
                    placeholder={t('onboarding.profile.holder_name')}
                    label={t('onboarding.profile.name')}
                    required
                    type="text"
                    value={this.props.name} />
                </div>
                <div className="form-group col-md-6">
                  <Input
                    className="form-control"
                    onChange={this.props.handleLastnameChange}
                    placeholder={t('onboarding.profile.holder_lastname')}
                    label={t('onboarding.profile.lastname')}
                    required
                    type="text"
                    value={this.props.lastname} />
                </div>
                <div className="form-group col-md-4">
                  <Input
                    className="form-control"
                    type="date"
                    label={t('onboarding.profile.birthdate')}
                    name="birthDate"
                    onChange={this.handleBirthDate}
                    min={new Date(1900, 0, 1).toISOString().split('T')[0]}
                    max={maxBirthYear.toISOString().split('T')[0]}
                    required
                  />
                </div>
                <div className="form-group col-md-4">
                  <Input
                    className="form-control"
                    onChange={this.props.handlePhoneChange}
                    placeholder={t('onboarding.profile.holder_phone')}
                    label={t('onboarding.profile.phone')}
                    required
                    type="tel"
                    pattern='[0-9]{10}'
                    value={this.props.phone} />
                </div>
                <div className="form-group col-md-4">
                  <label>
                    {t('onboarding.profile.gender')}
                  </label>
                  <select
                    className="form-control"
                    onChange={this.props.handleGenderChange}
                    required
                  >
                    <option value="">{t('dashboard.contact.holder_subject')}</option>
                    <option value={GENDER.FEMALE}>{t('onboarding.profile.gender_female')}</option>
                    <option value={GENDER.MALE}>{t('onboarding.profile.gender_male')}</option>
                    <option value={GENDER.OTHER}>{t('onboarding.profile.gender_other')}</option>
                  </select>
                </div>
              </div>
              <br />
              <div className="col-md-12">
                <p className="small signup">
                  <Trans i18nKey='onboarding.profile.terms'>
                    * Al crear tu cuenta aceptas nuestros&nbsp;
                    <a href="https://www.iosoffices.com/condiciones-de-uso" rel="noopener noreferrer" target="_blank">términos y condiciones de uso</a>.
                  </Trans>
                </p>
                <p className="small signup">
                  <Trans i18nKey='onboarding.profile.privacy'>
                    Consulta nuestro&nbsp;
                    <a href="https://www.iosoffices.com/aviso-de-privacidad" rel="noopener noreferrer" target="_blank">aviso de privacidad</a>.
                  </Trans>
                </p>
              </div>
              <div className="form-group">
                <button
                  className="btn btn-block btn-primary"
                  type="submit">
                  {t('onboarding.profile.btn_profile')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Profile);



// WEBPACK FOOTER //
// ./src/onboarding/Profile.js